import { useEffect, useState } from "react";
import { X, Cookie } from "lucide-react";

const KEY = "ucs_cookie_consent_v1";

export const CookieBanner = () => {
    const [show, setShow] = useState(false);
    const [details, setDetails] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(KEY)) setShow(true);
    }, []);

    const decide = (choice) => {
        localStorage.setItem(KEY, JSON.stringify({ choice, ts: new Date().toISOString() }));
        setShow(false);
    };

    if (!show) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[60] p-4 md:p-6" data-testid="cookie-banner">
            <div className="max-w-5xl mx-auto bg-[#0E2C4D] text-white shadow-2xl border border-[#EC6A0A]/30" style={{borderRadius: 4}}>
                <div className="p-6 md:p-7 grid md:grid-cols-12 gap-6 items-center">
                    <div className="md:col-span-7 flex gap-4">
                        <div className="w-10 h-10 bg-[#EC6A0A]/15 text-[#EC6A0A] flex items-center justify-center flex-shrink-0" style={{borderRadius: 2}}>
                            <Cookie className="w-5 h-5" />
                        </div>
                        <div>
                            <div className="font-bold mb-1">Wij respecteren uw privacy</div>
                            <p className="text-sm text-white/75 leading-relaxed">
                                Deze website gebruikt enkel functionele cookies om u een goede ervaring te bieden.
                                Voor analyse en marketing vragen wij uw toestemming (GDPR / Belgische privacywet).
                            </p>
                            {details && (
                                <ul className="mt-3 text-xs text-white/65 list-disc pl-4 space-y-1">
                                    <li><strong>Functioneel</strong> — noodzakelijk voor inloggen, formulieren en navigatie (altijd actief).</li>
                                    <li><strong>Analytisch</strong> — anonieme statistieken om de site te verbeteren.</li>
                                    <li><strong>Marketing</strong> — optionele cookies voor advertenties.</li>
                                </ul>
                            )}
                            <button onClick={() => setDetails(!details)} className="mt-2 text-xs text-[#EC6A0A] underline" data-testid="cookie-details-toggle">
                                {details ? "Minder details" : "Meer details"}
                            </button>
                        </div>
                    </div>
                    <div className="md:col-span-5 flex flex-col sm:flex-row gap-3 md:justify-end">
                        <button onClick={() => decide("essential")}
                                className="px-5 py-3 text-sm font-semibold border border-white/30 hover:bg-white/5 transition-colors"
                                style={{borderRadius: 2}} data-testid="cookie-essential">
                            Enkel essentiële
                        </button>
                        <button onClick={() => decide("all")}
                                className="ucs-btn-accent justify-center text-sm" data-testid="cookie-accept-all">
                            Alles aanvaarden
                        </button>
                    </div>
                    <button onClick={() => decide("dismiss")} className="absolute top-3 right-3 text-white/50 hover:text-white p-2"
                            data-testid="cookie-close" aria-label="Sluiten">
                        <X className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </div>
    );
};
